import { CaseType } from "@teamprevent/common/model";

import { DashboardState, DashboardCaseType } from "./model";
import { DashboardAction } from "./actions";
import * as actions from "./actionTypes";

export function dashboard(state: DashboardState = { caseCount: [] }, action: DashboardAction): DashboardState {

    const getCaseCount = (caseType: DashboardCaseType) => {
        return [...state.caseCount.filter(cc => cc.type !== caseType), { type: caseType, count: action.payload }];
    };

    switch (action.type) {
        case actions.LOAD_OH_CASE_COUNT_SUCCESS:
            return { ...state, caseCount: getCaseCount("All") };
        case actions.LOAD_WORK_ADJUSTMENT_COUNT_SUCCESS:
            return { ...state, caseCount: getCaseCount(CaseType.WORK_ADJUSTMENT) };
        default:
            return state;
    }
}
